import { render, staticRenderFns } from "./rider.vue?vue&type=template&id=3da621aa&scoped=true&"
import script from "./rider.vue?vue&type=script&lang=js&"
export * from "./rider.vue?vue&type=script&lang=js&"
import style0 from "./rider.vue?vue&type=style&index=0&id=3da621aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da621aa",
  null
  
)

export default component.exports